module.exports = __webpack_public_path__ + "static/media/Picture1.1ccffa38.png";